import type { FunctionComponent, TargetedEvent } from 'preact';

import type { InputTemplateFunction } from 'Components/types';
import t from 'Utils/translate';

export type Params = void;

type Props = {
  template: InputTemplateFunction;
  filterValue: string;
  facetName: string;
  facetField: string;
  onChange: (e: TargetedEvent<HTMLInputElement, Event>) => void;
};

const FilterInput: FunctionComponent<Props> = ({
  template,
  filterValue,
  facetName,
  facetField,
  onChange,
}) => {
  const templProps = template()?.props;

  const props = {
    type: 'text',
    autoComplete: 'off',
    className: templProps?.className ?? 'cm_filterInput',
    id: `cm_filter-input-${facetField}`,
    placeholder: `${templProps?.placeholder || t('facet_filter_placeholder')} ${facetName}...`,
    value: filterValue,
    onChange: (e: TargetedEvent<HTMLInputElement, Event>) => {
      templProps?.onChange?.(e);
      onChange(e);
    },
  };
  return <input {...props} />;
};

export default FilterInput;
